
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_7378_118753)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_7378_118753)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.199 6.18c-.398.484-.654.926-.752 1.217-.237.706-.662 4.317 3.353 8.062 2.035 1.898 3.948 2.8 5.417 3.198 1.516.411 2.496.274 2.68.209.234-.083.64-.306 1.134-.673.454-.338.933-.76 1.354-1.22a902.175 902.175 0 00-2.698-2.591l-1.511 1.511-.416.419-.568-.162c-.29-.083-2.328-.68-4.175-2.527-.927-.926-1.412-1.761-1.659-2.448a3.995 3.995 0 01-.21-.873c-.027-.213-.028-.433-.027-.411l-.023-.455.328-.315c.116-.112.89-.887 1.496-1.494l-2.528-2.6c-.418.31-.84.72-1.195 1.153zM4.653 4.91a8.8 8.8 0 011.713-1.607c.826-.575 1.83-.32 2.406.272.682.7 1.846 1.899 2.585 2.66a1.998 1.998 0 01-.018 2.804l-1.18 1.18c.017.081.043.173.081.28.135.376.446.965 1.19 1.71a8.387 8.387 0 002.771 1.83l1.072-1.072a1.997 1.997 0 012.795-.032c.759.727 1.965 1.882 2.753 2.645.7.676.85 1.84.124 2.65a11.842 11.842 0 01-1.72 1.568c-.564.419-1.156.775-1.663.954-.702.248-2.127.308-3.869-.165-1.788-.485-3.988-1.55-6.257-3.666C2.842 12.637 3.066 8.203 3.55 6.76c.206-.612.627-1.27 1.102-1.848z","fill":"#161616","fill-opacity":".72"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_7378_118753"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h24v24H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_7378_118753"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    